module.exports = __webpack_public_path__ + "static/media/zuccinni.26ba1aa6.png";